const a = (t) => t.replace(/[-_]/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").split(" ").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
export {
  a as formatObjectKey
};
